import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section id="accueil" className="hero">
      <div className="container">
        <div className="hero__content">
          <div className="hero__text animate-fade-in-up">
            <h1 className="hero__title">
              La première place de marché
              <span className="text-primary"> avicole</span> du Mali
            </h1>
            <p className="hero__subtitle">
              Vendez et achetez facilement vos produits avicoles : poussins,
              œufs, chair, et tous produits relatifs aux volailles. Une
              plateforme sécurisée et intuitive pour connecter éleveurs et
              acheteurs.
            </p>
            <div className="hero__buttons flex flex--center">
              <a href="#telecharger" className="btn btn--primary btn--large">
                📱 Télécharger l'app
              </a>
              <a
                href="#fonctionnalites"
                className="btn btn--secondary btn--large"
              >
                Découvrir les fonctionnalités
              </a>
            </div>
          </div>

          <div className="hero__image animate-fade-in">
            <div className="hero__phone-mockup">
              <img
                src="/01-home.PNG"
                alt="Interface principale de Chiesugu"
                className="hero__phone-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
